import PropTypes from 'prop-types'
import React, { useState, useEffect, useCallback } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { useInput } from '@/checkout-instore-legacy/commons/customHooks'

import Input from '@vtex/styleguide/lib/Input'
import Button from '@vtex/styleguide/lib/Button'

import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import { usePrevious } from '@/checkout-instore-legacy/hooks/usePrevious'

const ProductBarcodeArea = function ({ searchEan, itemLoading, itemError }) {
  const prevItemLoading = usePrevious(itemLoading)
  const [ean, handleEanChange] = useInput('')
  const [isPristine, setIsPristine] = useState(true)

  useEffect(() => {
    if (prevItemLoading && !itemLoading) {
      if (!itemError && isPristine) {
        handleEanChange({ target: { value: '' } })
      }
    }
  }, [handleEanChange, isPristine, itemError, itemLoading, prevItemLoading])

  const handleInputOnChange = useCallback(
    (e) => {
      isPristine && setIsPristine(false)
      handleEanChange(e)
    },
    [handleEanChange, isPristine]
  )

  const handleOnClick = useCallback(() => {
    setIsPristine(true)
    searchEan(ean)
  }, [ean, searchEan])

  return (
    <div
      className="flex flex-column items-center ba bw1 b--dashed b--muted-4 pa6 mt3 br3"
      style={{ background: 'rgba(255, 255, 255, 0.3)' }}
    >
      <div className="self-stretch">
        <span>
          <FormattedMessage id="returnExchange.identify.barcode.type" />
        </span>
        <div className="pt2">
          <Input
            value={ean}
            size={'large'}
            onChange={handleInputOnChange}
            suffix={
              <span className="nr4">
                <Button
                  isLoading={itemLoading}
                  variation="tertiary"
                  onClick={handleOnClick}
                >
                  <span className="ttu">
                    <FormattedMessage id="returnExchange.identify.add" />
                  </span>
                </Button>
              </span>
            }
          />
        </div>
      </div>
      <span className="pt6">
        <FormattedMessage id="returnExchange.or" />
      </span>
      <div className="c-on-base">
        <Icon type="nc-barcode-scan" width={78} heigth={57} color="#4A4A4A" />
      </div>
      <span className="mb4">
        <FormattedMessage id="returnExchange.identify.barcode.scan" />
      </span>
    </div>
  )
}

ProductBarcodeArea.propTypes = {
  searchEan: PropTypes.func.isRequired,
  itemError: PropTypes.object,
  itemLoading: PropTypes.bool,
}

export default withRouter(injectIntl(ProductBarcodeArea))
